export const langs = {
  UZ: "UZ",
  RU: "RU",
};
